import { keywordActions } from "../../actionTypes";

const initialState = {
	attachedKeywords: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case keywordActions.ATTACH_KEYWORDS: {
			return { ...state, ...initialState };
		}

		case keywordActions.ATTACH_KEYWORDS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				attachedKeywords: action.payload.data,
			};
		}

		case keywordActions.ATTACH_KEYWORDS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
